module.exports = __webpack_public_path__ + "static/media/20_Maf_NuestroEquipo_EduardoVidal.d37e3e76.jpg";